module.exports = __webpack_public_path__ + "images/14-02_20315cd4.jpg";